var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "BookmarkCard actualiteCard" }, [
    _c("div", { staticClass: "BookmarkCard-card actualiteCard-card" }, [
      _c("div", { staticClass: "actualiteCard-title" }, [
        _c(
          "div",
          {
            staticClass: "BookmarkCard-tag actualiteCard-tag",
            style: {
              "--background-color": _vm.getActualiteTypeColor()
            }
          },
          [_c("span", [_vm._v(" " + _vm._s(_vm.getActualiteTypeLabel()))])]
        ),
        _c("div", { staticClass: "actualiteCard-publish" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$t("actualitesPage.date-publication", [
                  _vm.formatDate(_vm.actualite.dateDebutPublication)
                ])
              )
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "actualiteCard-content" }, [
        _c("div", { staticClass: "actualite-content-title" }, [
          _vm._v(_vm._s(_vm.actualite.titre))
        ]),
        _c("div", { staticClass: "actualite-text-container" }, [
          _c("div", { staticClass: "text-container" }, [
            _c("span", [_vm._v(_vm._s(_vm.getActualiteTruncateContent()))]),
            _vm.isReadMore
              ? _c(
                  "span",
                  {
                    staticClass: "read-more",
                    attrs: { id: "read-more-" + _vm.actualite.id }
                  },
                  [_vm._v(_vm._s(_vm.$t("actualitesPage.read-more")))]
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }